"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Groups = exports.NAMESPACE = exports.Device = exports.Admin = void 0;
const admin_1 = require("./admin");
const device_1 = require("./admin/device");
const factory_1 = require("./device/factory");
const manufacturing_1 = require("./device/manufacturing");
const service_menu_1 = require("./device/service-menu");
exports.Admin = __importStar(require("./admin"));
exports.Device = __importStar(require("./device"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy';
/**
 * Documentation-only contracts for the v2 routes still served by Express.
 *
 * Each module under this directory exports one or more `HttpApiGroup` values
 * describing legacy routes (method, path, parameters, bodies, responses,
 * security) without any handler. Register every group here so it becomes part
 * of `V2.Spec.Complete` and, through its `Audience` annotation, of the
 * filtered documents.
 *
 * Nothing in this registry is ever served: `V2.Spec.Spec` stays the runtime
 * contract implemented by the unified-api handlers.
 */
exports.Groups = [
    admin_1.Tenant.Spec,
    factory_1.Spec,
    manufacturing_1.Spec,
    service_menu_1.Spec,
    device_1.Spec,
];
//# sourceMappingURL=index.js.map